import styled from 'styled-components/macro';
import SimpleList from 'styled/SimpleList';

const CardsList = styled(SimpleList)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
  margin: 0;
  padding: 20px 32px 0 24px;
`;

export default CardsList;
